import { BaseService } from "./base.service";
import LoginModel from "models/LoginModel";
import {
	IExternalUserLoginResponse,
	IRefreshTokenResponse,
} from "models/LoginUserDetail";
import { ForgetPasswordModel } from "models/SignUp/ExternalUser";

class AuthServiceInternal extends BaseService {
	internalUserAuthentication = async (): Promise<any> =>
		this.callApi<any>(`Auth/InternalUser/Login`, "GET");

	checkInternalUserExist = async (): Promise<any> =>
		this.callApi<any>(`Auth/CheckInternalUserExist`, "GET");

	externalUserLogin = async (
		model: LoginModel
	): Promise<{ loginResponse: IExternalUserLoginResponse }> =>
		this.callApi<{ loginResponse: IExternalUserLoginResponse }>(
			`Auth/ExternalUser/Login`,
			"POST",
			undefined,
			model,
			undefined,
			undefined,
			false
		);

	refreshAuthToken = async (
		token: string,
		refreshToken: string
	): Promise<IRefreshTokenResponse> =>
		this.callApi<IRefreshTokenResponse>(
			`Auth/ExternalUser/RefreshToken`,
			"POST",
			undefined,
			{
				token: token,
				refreshToken: refreshToken,
			},
			undefined,
			undefined,
			false
		);

	forgetPassword = async (model: ForgetPasswordModel): Promise<number> =>
		this.callApi<number>(
			`Auth/ExternalUser/ForgetPassword`,
			"POST",
			undefined,
			model,
			false,
			false,
			false
		);

	forgotPasswordVerifyOtp = async (
		userId: number,
		otpNumber: string
	): Promise<{ isVerified: boolean; token: string }> =>
		this.callApi<{ isVerified: boolean; token: string }>(
			`UserAuthenticationOtp/VerifyOtp/${userId}/${otpNumber}`,
			"POST",
			undefined,
			undefined,
			false,
			false,
			false
		);

	changePassword = async (
		password: string,
		token: string
	): Promise<undefined> =>
		this.callApi<undefined>(
			`Auth/ExternalUser/ChangePassword`,
			"POST",
			undefined,
			{
				token: token,
				password: password,
			},
			false,
			false,
			false
		);
}

export const AuthService = new AuthServiceInternal();
